<template>
  <input type="text" v-model="zip" placeholder="" autocomplete="new-password" :disabled="disabled" />
  <p class="error" v-if="errorMessage">{{ errorMessage }}</p>
</template>

<script setup lang="ts">
import { ref, watch, computed } from "vue";
import { searchStateByZipCode } from "../api/zip.api";
import { useDistanceStore } from "../store/distance.store";
import { useNewEstimateStore } from "@/stores/new/estimateStore";

const distanceStore = useDistanceStore();
const estimateStore = useNewEstimateStore();
const isShippingAndBillingEqual = computed(() => estimateStore.isShippingAndBillingEqual);

const zip = defineModel<string>("zip");
const state = defineModel("state");
const type = defineModel("type");
const disabled = defineModel("disabled", { default: false });

const errorMessage = ref<string | null>(null);

const getStateInfo = async (value, autoComplete = true) => {
  if (!isShippingAndBillingEqual.value && !autoComplete) return

  const { data: foundedState, error } = await searchStateByZipCode(value);

  if (error) {
    errorMessage.value = error || "State not found";
    state.value = "";
    return;
  }
  estimateStore.estimate.taxLimit = foundedState.state?.tax_limit;
  estimateStore.estimate.taxStatus = foundedState.state.tax_status;
  estimateStore.estimate.taxPercent = foundedState.zipCode.estimate_rate;

  state.value = foundedState.state?.code;
};

watch(
  () => zip.value,
  async (value) => {
    errorMessage.value = null;
    if (!value || value.length < 5) return;

    if (type.value === "shipping") {
      distanceStore.fetchDistance(value, false);
    }

    await getStateInfo(value);
  },
);
watch(
  () => estimateStore.estimate?.shippingZip,
  async (value) => {
    if (!value || value.length < 5) return;
    await getStateInfo(value, type.value !== 'billing');
  },
  {
    immediate: true,
  },
);
</script>

<style scoped>
.error {
  grid-column: 2 / 2;

  color: red;
  font-size: 12px;
  margin-top: 8px;
}

.step__block--data .step__block-container input,
.step__block-wrapper .step__block-container input {
  padding: 9px 20px;
  background-color: #fff;
  border-radius: 25px;
  color: #404d63;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.step__block--data .step__block-container input:disabled,
.step__block-wrapper .step__block-container input:disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
